import { validateUrl } from '../../../helpers/validatorsHelper';

const generateMessageWithLinks = (message) => message
  .split(' ')
  .map((word) => {
    if (!validateUrl(word)) return word;
    return `<a style="color: red" href="${word}" target="_blank">${word}</a>`;
  })
  .join(' ');

export default generateMessageWithLinks;
